import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/status",
        component: List,
        name: "status-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/status/:id/edit",
        component: Edit,
        name: "status-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/status/create",
        component: Create,
        name: "status-create",
        meta: {
            requiresAuth: true,
        },
    },
];
